/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Save_FailedInputs */

const en_carrier_notices_save_failed = /** @type {(inputs: Carrier_Notices_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save carrier notice.`)
};

const es_carrier_notices_save_failed = /** @type {(inputs: Carrier_Notices_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar el aviso de transportista.`)
};

/**
* | output |
* | --- |
* | "Failed to save carrier notice." |
*
* @param {Carrier_Notices_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_save_failed = /** @type {((inputs?: Carrier_Notices_Save_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Save_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_save_failed(inputs)
	return es_carrier_notices_save_failed(inputs)
});